module.exports = __webpack_public_path__ + "static/media/parkhub-scheduler-logo-gray.5b3f2197.svg";